import { actionTypes } from '../actions/data';

// DEFAULT STATE
export const initParams = {

  // Mapping of headers to postfixes for the eloqua records. Allows us to match
  // multiple subscriptions to the same 'thing' (e.g., use wants factsheets and performance reports
  // for DES)
  headerMapping: {
    'Quarterly Factsheet': 'QS',
    'Monthly Performance': 'MP',
    'Monthly ETF Performance': 'MEP',
    'Quarterly Allocation/ Rebalance': 'QA',
    'Product List': 'PL',
    'Quarterly Dividend Yield': 'QDY',
    'Quarterly Distribution History Report': 'QDH',
    'Quarterly Updates': 'QU',
  },
};

// WRITES
const params = (state, action) => {
  if (state === undefined) {
    return {};
  }
  switch (action.type) {

    case actionTypes.INVALIDATE_PARAMS:

      // Params are not valid
      return Object.assign({}, state, {
        paramsValid: false,
      });

    case actionTypes.UNSUBSCRIBED_FROM_ALL:

        // Set unsubscribe to false as you only want this flagged once per page refresh
        return Object.assign({}, state, {
          unsubscribe: false,
        });

    default:
      return state;
  }
}

// READS
export const getApiUrl = state => state.params.apiURL;
export const getVersion = state => state.params.version;
export default params;
